import React from 'react';
import { createRoot } from 'react-dom/client';
import './assets/styles.css';
import AppRouter from './AppRouter/AppRouter';
import AppRouterComponent from './AppRouter/AppRouterComponent';
import { IntlProvider } from 'react-intl';
import formats from './common/translate/formats';
import * as messages from './common/translate/languages/';
import { AppStateContext, AuthContext, ErrorContext, IntlContext, PartnerContext } from './Context';
import AuthService from './Auth/AuthService';
import ErrorHandler from './components/ErrorHandlerComponent';
import Login from './components/Login';
import VersionsMismatchModal from './components/VersionsMismatchModal';

const dashToUScore = str => str.replace('-', '_');

const container = document.getElementById('root');
const root = createRoot(container);

function AppBootstrap() {
  // A public route (the logout page) neither needs the session nor requests it; the page is opened by a full load
  const isPublicRoute = AppRouter.isPublicRoute(AppRouter.location);

  React.useEffect(() => {
    if (!isPublicRoute) {
      // API interceptors already display session request errors.
      AuthService.loadSession().catch(() => {});
    }
  }, [isPublicRoute]);

  return (
    <>
      <AuthContext.Consumer>{auth => (auth.showLoginModal ? <Login /> : null)}</AuthContext.Consumer>
      <AppStateContext.Consumer>
        {appState =>
          appState.sessionValidated || isPublicRoute ? (
            <AppRouterComponent />
          ) : (
            <>
              <ErrorContext.Consumer>{errorProps => <ErrorHandler {...errorProps} />}</ErrorContext.Consumer>
              <VersionsMismatchModal isShown={appState.versionsMismatch} />
            </>
          )
        }
      </AppStateContext.Consumer>
    </>
  );
}

root.render(
  <IntlContext.Provider>
    <IntlContext.Consumer>
      {locale => {
        return (
          <IntlProvider locale={locale.locale} messages={messages[dashToUScore(locale.locale)]} formats={formats}>
            <AuthContext.Provider>
              <ErrorContext.Provider>
                <AppStateContext.Provider>
                  <PartnerContext.Provider>
                    <AppBootstrap />
                  </PartnerContext.Provider>
                </AppStateContext.Provider>
              </ErrorContext.Provider>
            </AuthContext.Provider>
          </IntlProvider>
        );
      }}
    </IntlContext.Consumer>
  </IntlContext.Provider>
);
